<script setup lang="ts">
import IconButton from '../IconButton/IconButton.vue';
import type { TRightSidebarProps } from './sidebar';

const props = withDefaults(defineProps<TRightSidebarProps>(), {
  overlapping: false,
  width: '320px',
});

const emit = defineEmits<{
  close: [];
}>();
</script>

<template>
  <div
    class="h-full transition-all duration-200 ease-in-out"
    :class="[
      props.overlapping ? 'absolute top-0 right-0 z-50' : 'relative',
      'border-neutral-200',
    ]"
    :style="{
      width: props.isOpen ? props.width : '0px',
      minWidth: props.isOpen ? props.width : '0px',
      maxWidth: props.isOpen ? props.width : '0px',
      borderLeftWidth: props.isOpen ? '1px' : '0px',
      boxShadow: props.isOpen
        ? '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
        : 'none',
    }"
  >
    <div
      class="flex h-full flex-col overflow-hidden bg-white transition-opacity duration-200"
      :class="{ 'opacity-0': !props.isOpen, 'opacity-100': props.isOpen }"
    >
      <!-- Header -->
      <div class="relative flex items-center justify-between p-4 pb-2">
        <div class="flex-1 overflow-hidden">
          <slot name="header"></slot>
        </div>
        <IconButton
          class="ml-2"
          variant="ghost-neutral"
          icon="cancel"
          size="sm"
          @click="emit('close')"
        />
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-y-auto px-4 py-2">
        <slot></slot>
      </div>

      <!-- Footer -->
      <div v-if="$slots.footer" class="border-t border-neutral-100 p-4 pt-2">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
